module.exports = __webpack_public_path__ + "media/dashboard/assets/images/empty_state-a5e715819643cc615834580b64894d0d.svg";